import React from 'react';

import { Card } from 'ui-components/components/card';

import style from './style.module.less';

/**
 * Returns tab section container component
 * Wraps content in a Card with appropriate styling
 * @typedef {object} ReturnsTabSectionProps
 * @property {React.ReactNode} children - The content to be displayed inside the section
 * @param {ReturnsTabSectionProps} props - Component props
 * @returns {React.ReactElement} The Returns tab section container
 */
export const ReturnsTabSection = ({ children }) => <Card className={style.returnsTabSection}>{children}</Card>;
